import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news11Img from "../../images/news/news1/news1_1.jpg";
import news12Img from "../../images/news/news1/news1_2.jpg";
import news13Img from "../../images/news/news1/news1_3.jpg";
import news14Img from "../../images/news/news1/news1_4.jpg";
import news15Img from "../../images/news/news1/news1_5.jpg";
import news16Img from "../../images/news/news1/news1_6.jpg";
import news17Img from "../../images/news/news1/news1_7.jpg";
import news18Img from "../../images/news/news1/news1_8.jpg";
import news19Img from "../../images/news/news1/news1_9.jpg";
import news110Img from "../../images/news/news1/news1_10.jpg";
import news111Img from "../../images/news/news1/news1_11.jpg";
import news112Img from "../../images/news/news1/news1_12.jpg";
import news113Img from "../../images/news/news1/news1_13.jpg";
import news114Img from "../../images/news/news1/news1_14.jpg";
import news115Img from "../../images/news/news1/news1_15.jpg";
import news116Img from "../../images/news/news1/news1_16.jpg";
import news117Img from "../../images/news/news1/news1_17.jpg";
import news118Img from "../../images/news/news1/news1_18.jpg";
import news119Img from "../../images/news/news1/news1_19.jpg";
import news120Img from "../../images/news/news1/news1_20.jpg";
import news121Img from "../../images/news/news1/news1_21.jpg";
import news122Img from "../../images/news/news1/news1_22.jpg";
import news123Img from "../../images/news/news1/news1_23.jpg";
import news124Img from "../../images/news/news1/news1_24.jpg";
import news125Img from "../../images/news/news1/news1_25.jpg";
import news126Img from "../../images/news/news1/news1_26.jpg";
import news127Img from "../../images/news/news1/news1_27.jpg";
import news128Img from "../../images/news/news1/news1_28.jpg";
import news129Img from "../../images/news/news1/news1_29.jpg";
import news130Img from "../../images/news/news1/news1_30.jpg";
import news131Img from "../../images/news/news1/news1_31.jpg";

import { withTranslation } from "react-i18next";


class news1 extends Component {
	componentDidMount() {

	}

	componentWillMount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("News1_Title");
	}

	componentWillUnmount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("Home_Title");
	}

	render() {
		const { t } = this.props;
		return (
			<>
				<Header />

				<div className="page-content">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("News1_Title")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("News1_LinkHome")}</Link>
								</li>
								<li>{t("News1_LinkCourses")}</li>
							</ul>
						</div>
					</div>
					<div className="content-block">
						<div className="section-area section-sp1">
							<div className="container">
								<div className="row d-flex flex-row-reverse">
									<div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
										<div className="courses-post">
											<h1>{t("News1_Content_H")}</h1>
											<p>{t("News1_Content_P1")}</p>
											<img src={news11Img} alt="" />
											<img src={news12Img} alt="" />
											<img src={news13Img} alt="" />
											<img src={news14Img} alt="" />
											<img src={news15Img} alt="" />
											<img src={news16Img} alt="" />
											<img src={news17Img} alt="" />
											<img src={news18Img} alt="" />
											<img src={news19Img} alt="" />
											<img src={news110Img} alt="" />
											<img src={news111Img} alt="" />
											<img src={news112Img} alt="" />
											<img src={news113Img} alt="" />
											<img src={news114Img} alt="" />
											<img src={news115Img} alt="" />
											<img src={news116Img} alt="" />
											<img src={news117Img} alt="" />
											<img src={news118Img} alt="" />
											<img src={news119Img} alt="" />
											<img src={news120Img} alt="" />
											<img src={news121Img} alt="" />
											<img src={news122Img} alt="" />
											<img src={news123Img} alt="" />
											<img src={news124Img} alt="" />
											<img src={news125Img} alt="" />
											<img src={news126Img} alt="" />
											<img src={news127Img} alt="" />
											<img src={news128Img} alt="" />
											<img src={news129Img} alt="" />
											<img src={news130Img} alt="" />
											<img src={news131Img} alt="" /><hr />
											<p>{t("News1_Content_P2")}</p>
											<p style={{ color: "crimson" }}>{t("News1_Content_P3")}</p>
											<p style={{ whiteSpace: "pre-line" }}>{t("News1_Content_P4")}</p>
											<p style={{ color: "red" }}>{t("News1_Content_P5")}</p>
											<p style={{ whiteSpace: "pre-line" }}>{t("News1_Content_P6")}</p>
											<p style={{ color: "red" }}>{t("News1_Content_P7")}</p>
											<p style={{ whiteSpace: "pre-line" }}>{t("News1_Content_P8")}</p>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default news1 = withTranslation()(news1);
